/**
 * The A–Z bar's buckets, in display order. "#" holds every name that doesn't start with a letter.
 *
 * Written out rather than spread from a string: a spread widens each entry to `string`, and the
 * bucket type would then accept any value.
 */
export const ALPHA_BUCKETS = [
  'A',
  'B',
  'C',
  'D',
  'E',
  'F',
  'G',
  'H',
  'I',
  'J',
  'K',
  'L',
  'M',
  'N',
  'O',
  'P',
  'Q',
  'R',
  'S',
  'T',
  'U',
  'V',
  'W',
  'X',
  'Y',
  'Z',
  '#',
] as const;

export type AlphaBucket = (typeof ALPHA_BUCKETS)[number];

/**
 * Which A–Z bucket a name belongs to. Case- and accent-insensitive: "Élise" is under E.
 *
 * A name that doesn't start with a Latin letter — a digit, punctuation, a letter with no
 * decomposition such as "Ø", or no name at all — goes to "#" rather than being reachable only via
 * "All".
 */
export function alphaBucket(name: string | null): AlphaBucket {
  const first = name?.trim().normalize('NFD').charAt(0).toUpperCase() ?? '';
  return first >= 'A' && first <= 'Z' ? (first as AlphaBucket) : '#';
}
